import { Constantes } from "./../../utils/Constantes";
import { SPParse } from "../../utils/SPParse";

export class EHorarioRecepcionMPV {
    ID: string;
    Dia: string;
    NoHayAtencion: boolean;
    HoraInicio: string;
    HoraFin: string;
    TextoInformativoAntesHorario: string;
    TextoInformativoDuranteHorario: string;
    TextoInformativoDespuesHorario: string;

    constructor() {
        this.ID = "0";
        this.Dia = "";
        this.NoHayAtencion = false;
        this.HoraInicio = "";
        this.HoraFin = "";
        this.TextoInformativoAntesHorario = "";
        this.TextoInformativoDuranteHorario = "";
        this.TextoInformativoDespuesHorario = "";
    }

    public static parseJsonBack(element: any, lng: string): EHorarioRecepcionMPV {

        const objeto = new EHorarioRecepcionMPV();
        objeto.ID = SPParse.getNumber(element["id"]).toString();
        objeto.Dia = SPParse.getString(element["dia"]);
        objeto.NoHayAtencion = SPParse.getBool(element["noHayAtencion"]);
        objeto.HoraInicio = SPParse.getString(element["horaInicio"]);
        objeto.HoraFin = SPParse.getString(element["horaFin"]);
        objeto.TextoInformativoAntesHorario = lng === "es" ? SPParse.getString(element["textoInformativoAntesHorario"]) : SPParse.getString(element["textoInformativoAntesHorarioEN"]);
        objeto.TextoInformativoDuranteHorario = lng === "es" ? SPParse.getString(element["textoInformativoDuranteHorario"]) : SPParse.getString(element["textoInformativoDuranteHorarioEN"]);
        objeto.TextoInformativoDespuesHorario = lng === "es" ? SPParse.getString(element["textoInformativoDespuesHorario"]) : SPParse.getString(element["textoInformativoDespuesHorarioEN"]);
        return objeto;
    }


    public static parseJsonListBack(elements: any, lng: string): EHorarioRecepcionMPV[] {
        const Items: EHorarioRecepcionMPV[] = [];
        for (const element of elements)
        {
            const objeto = EHorarioRecepcionMPV.parseJsonBack(element, lng);            
            Items.push(objeto);
        }
        return Items;
    }
}
